import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import gamesReducer from './slices/gamesSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    games: gamesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
